if (!customElements.get('quick-add-inline')) {
  customElements.define(
    'quick-add-inline',
    class QuickAddInline extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.quick-add-inline__trigger');
        this.panel = this.querySelector('.quick-add-inline__panel');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.isOpen = false;
        this.onClickOutside = this.onClickOutside.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        if (!this.trigger || !this.panel) return;

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        });

        this.panel.querySelectorAll('[data-variant-id]').forEach((button) => {
          button.addEventListener('click', this.addVariant.bind(this));
        });

        document.addEventListener('click', this.onClickOutside);
        document.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onClickOutside);
        document.removeEventListener('keydown', this.onKeyDown);
      }

      toggle() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        document.querySelectorAll('quick-add-inline.is-open').forEach((element) => {
          if (element !== this) element.close();
        });

        this.isOpen = true;
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
      }

      close() {
        if (!this.isOpen) return;

        this.isOpen = false;
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }

      onClickOutside(event) {
        if (this.isOpen && !this.contains(event.target)) {
          this.close();
        }
      }

      onKeyDown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          this.close();
          this.trigger.focus();
        }
      }

      addVariant(event) {
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        const spinner = button.querySelector('.loading__spinner');

        if (!variantId || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'quick-add-inline',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add-inline',
              productVariantId: variantId,
              cartData: response,
            });

            this.close();
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }
    }
  );
}
